import { THelperActionType } from '../../actions/helper';

export const HELPER_SET_PAGE_ACTION_TYPE: THelperActionType = 'HELPER/SET_PAGE';
